import { ExportOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client';
import { Button, Card, Form } from 'antd';
import React, { useState } from 'react';
import { EXPORT_TYPES, MODULES } from '../../../common/constants';
import ExportDateRangeModal from '../../../components/ExportDateRangeModal';
import DownloadQrCodesButton from '../../../components/InventoryUnits/DownloadQrCodesButton';
import SyncQrCodesButton from '../../../components/InventoryUnits/SyncQrCodesButton';
import Portal from '../../../components/Portal';
import useInventoryUnitsFeature from '../../../hooks/useInventoryUnitsFeature';
import InventoryTable from '../components/InventoryTable';
import { REQUEST_LIBRARY_INVENTORY_EXPORT } from '../graphql/Mutations';

const Inventory = () => {
  const [form] = Form.useForm();
  const [exportFilter, setExportFilter] = useState();
  const [isExportLoading, setIsExportLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedInventoryIds, setSelectedInventoryIds] = useState([]);
  const [selectionResetKey, setSelectionResetKey] = useState(0);
  const { isUnitsFeatureEnabled } = useInventoryUnitsFeature();

  const renderUnitActionButtons = () =>
    isUnitsFeatureEnabled && (
      <>
        <SyncQrCodesButton
          isLibrary
          className="common-button"
          size="middle"
          selectedInventoryIds={selectedInventoryIds}
          onSuccess={() => setSelectionResetKey((prev) => prev + 1)}
        />
        <DownloadQrCodesButton
          isLibrary
          className="common-button ml-16"
          size="middle"
          selectedInventoryIds={selectedInventoryIds}
        />
      </>
    );

  const [requestLibraryInventoryExport] = useMutation(
    REQUEST_LIBRARY_INVENTORY_EXPORT,
    {
      onError: () => {},
    },
  );

  const handleExport = async (values) => {
    setIsExportLoading(true);
    const res = await requestLibraryInventoryExport({
      variables: {
        data: {
          type: EXPORT_TYPES?.LIBRARY_INVENTORY,
        },
        filter: {
          search: exportFilter?.search,
          brandIds: exportFilter?.brand,
          categoryIds: exportFilter?.category,
          materialIds: exportFilter?.material,
          ageGroupIds: exportFilter?.ageGroup,
          dateRange: {
            from: values?.date?.[0]?.startOf('day'),
            to: values?.date?.[1]?.endOf('day'),
          },
        },
      },
    });
    if (res?.data) {
      setIsModalOpen(false);
      form?.resetFields();
    }
    setIsExportLoading(false);
  };

  return (
    <>
      <Portal portalId="header-title-content">
        <div className="portal-header">{MODULES?.INVENTORY}</div>
      </Portal>
      <Portal portalId="header-right-content">
        {renderUnitActionButtons()}
        <Button
          className="common-button ml-16"
          size="middle"
          icon={<ExportOutlined />}
          onClick={() => setIsModalOpen(true)}
          loading={isExportLoading}
        >
          Export
        </Button>
      </Portal>
      <Portal portalId="header-right-content-phones">
        {renderUnitActionButtons()}
        <Button
          className="common-button ml-16"
          size="middle"
          icon={<ExportOutlined />}
          onClick={() => setIsModalOpen(true)}
          loading={isExportLoading}
        >
          Export
        </Button>
      </Portal>
      <ExportDateRangeModal
        form={form}
        onFinish={handleExport}
        loadings={isExportLoading}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
      <Card className="mobile-with-search-nav-actions-rack mobile-card-main no-scroll-bar">
        <InventoryTable
          exportFilter={exportFilter}
          setExportFilter={setExportFilter}
          handleExport={handleExport}
          isExportLoading={isExportLoading}
          onSelectedInventoryIdsChange={setSelectedInventoryIds}
          selectionResetKey={selectionResetKey}
        />
      </Card>
    </>
  );
};

export default Inventory;
